const celebrating = "/_app/immutable/assets/flexy-happy-young-man-celebrating-something.D4GlVeSE.svg";
export {
  celebrating as default
};
